export default __webpack_public_path__ + "static/SCHIMMEL-5be7ad57015f3039bc8c7c11aa3da301.jpg";